const converNumberToAlphabet = (value: number) => {
  const ASCII_POSITION = 97;
  return String.fromCharCode(ASCII_POSITION + value);
};

export default converNumberToAlphabet;
